import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import oinion from "../images/onion-photo.jpg";
import ricebasmati from "../images/basmati rice.jpg";
import miniket from "../images/non polish Miniket rice.jpg";
import handcrafts from "../images/handicrafts.jpg";
import greenchili from "../images/greenchili.jpg";
import ginnger from "../images/ginger.jpg";
import DhaniyaCorianderSeeds from "../images/DhaniyaCorianderSeeds.jpg";
import cloth from "../images/garments.jpg";
import director from "../images/director.jpeg";
import ScrollToTop from "react-scroll-to-top";
import woodenfurniture from "../images/wooden furnture.jpg";
import Canefurniture from "../images/Cane furniture.jpg";

import surgicalgoods from "../images/surgical goods.jpg";
import handmadejwellery from "../images/hand made jwellery.jpg";
import spices from "../images/spice-all.jpg";
import dairyproducts from "../images/dairy products.jpg";
import fruits from "../images/fruit.jpg";
import leatherproducts from "../images/LEATHER ACCESSORIES.jpg";
import MasoorDal from "../images/Masoor Dal photo.jpg";
import krishnagarmatirputul from "../images/matir putul.jpg";
import biri from "../images/biri.jpg";
import sarbhajasarpuria from "../images/sarbhaja_krishnagar.jpg";
import ReactPlayer from "react-player";

// import { DefaultPlayer as Video } from 'react-html5video';
// import 'react-html5video/dist/styles.css';
// import Frontvideo from "../images/Rice Video.MP4";
import africameet from "../images/africa meet.jpeg";
import africaphoto from "../images/africa container import.jpeg"
import africawiththehopingsunexim from "../images/africa photo.jpeg";

import "./Home.css";
import Garments from './Garments';
import Canefurnitures from './Canefurnitures';
import Dhaniya from './Dhaniya';

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />

      <div className="album py-2">
        <div className="container">
          <h5>The Hoping Sun Exim</h5>
        </div>
      </div>
      <ScrollToTop smooth top="100" color="Darkblue" />
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/shorts/5c4PjQGYaJs" />

            </div>
            <div className="col-md-8 mt-3">
              <Slider />
            </div>

          </div>
        </div>

      </div>
      <br />

      <div className='exporter'>
        <div className="album py-0">
          <div className="container ">
            <marquee>
              <div className='tastenew'>
                <h4 className='mt-2'>Welcome to The Hoping Sun Exim | Best Quality Product & Services Exporter </h4>
              </div>
            </marquee>
          </div>
        </div>
      </div>
      <br />
      <div style={{ margin: 12 }} className="fixed-bottom mt-0">

        <a className='connect' href='tel: 8695269630'>Connect to THSE</a>
      </div>


      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">


              <div className="card-body">
                <h1 className="card-title mb-3 textjustify"><b>About</b> THE HOPING SUN EXIM</h1>
                <h5 className="card-text mb-2 textjustify">Welcome to The Hoping Sun Exim! We are a trusted name in the export of premium Agriculture and Garment Products, bringing the finest quality of goods to global markets. With a commitment to excellence, innovation, and sustainability, we ensure that our products meet the highest international standards.</h5>
                <h5>Our mission is to bridge the gap between superior-quality Indian products and global demand. We aim to deliver excellence while fostering long-term relationships with our clients through trust, transparency, and reliability.</h5>

              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='borderradius'>
                <img src={director} className="card-img-top" alt="director" />
              </div>

            </div>
          </div>
        </div>
      </div>
      <br />
      <div className='gallery'>
        <br/>
        <div className="album py-0">
        <div className="container">
          <h1 style={{color:"#1477a5"}}><b>Gallery Page </b></h1>
          </div>
        </div>

          <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
               <img src={africameet} className="card-img-top" alt="africameet" />

              </div>
              <div className="col-md-4 mt-3">
                       <img src={africaphoto} className="card-img-top" alt="africaphoto" />
              </div>
              <div className="col-md-4 mt-3">
                       <img src={africawiththehopingsunexim} className="card-img-top" alt="africawiththehopingsunexim" />
              </div>

              </div>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-end mb-0 mt-2">
                                        <a href='Gallery'>
                                            <button className='africa mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></button>
                                        </a>
                                    </div>
            <br/>
            </div>
            <br/>
            <hr/>
      <div className="album py-0">
        <div className="container">
          <div className='colortext'>
            <h1><b>Products</b></h1>
          </div>
        </div>
      </div>


      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='Basmati-rice'>
                  <img src={ricebasmati} className="card-img-top" alt="best ricebasmati expoter in india" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Basmati Rice</h5>
                  <a href="Basmati-rice" className="exporterindia">Learn More</a>
                </div>

              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='miniket-rice'>
                  <img src={miniket} className="card-img-top" alt="best miniket expoter in india" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Non Polish Miniket Rice</h5>
                  <a href="miniket-rice" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <img src={oinion} className="card-img-top" alt="best onion expoter in india" />
                <div className="card-body">
                  <h5 className="card-title">Fresh Onion</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='handcraft'>
                  <img src={handcrafts} className="card-img-top" alt="handcrafts" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Handcraft Product</h5>
                  <a href="handcraft" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <img src={greenchili} className="card-img-top" alt="greenchilli" />
                <div className="card-body">
                  <h5 className="card-title">Green Chilli</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='Ginger'>
                  <img src={ginnger} className="card-img-top" alt="ginnger" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Ginger</h5>
                  <a href="Ginger" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='dhaniya-seed'>
                  <img src={DhaniyaCorianderSeeds} className="card-img-top" alt="DhaniyaCorianderSeeds-india" />
                </a>
                <div className="card-body">
                  <h5 className="card-title"> Dhaniya ( Coriander Seeds)</h5>
                  <a href="dhaniya-seed" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='garments'>
                  <img src={cloth} className="card-img-top" alt="best cloth exporter in india" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Garments</h5>
                  <a href="garments" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={leatherproducts} className="card-img-top" alt="leatherproducts" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Leather Products</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={woodenfurniture} className="card-img-top" alt="wooden furniture exporter Kolkata" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Wooden Furniture</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>


            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='cane-furniture'>
                  <img src={Canefurniture} className="card-img-top" alt="best Cane Furniture in india" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Cane Furniture</h5>
                  <a href="cane-furniture" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={surgicalgoods} className="card-img-top" alt="surgical goods" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Surgical Goods</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={handmadejwellery} className="card-img-top" alt="hand made jwellery_Krishnagar" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Handmade Jwellery</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>


            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={spices} className="card-img-top" alt="different types of spices" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Different types of spices</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>


            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='dairy'>
                  <img src={dairyproducts} className="card-img-top" alt="dairyproducts" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Dairy Products</h5>
                  <a href="dairy" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='Masoordal'>
                  <img src={MasoorDal} className="card-img-top" alt="MasoorDalexport" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">Masoor Dal</h5>
                  <a href="Masoordal" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card">
                <a href='#'>
                  <img src={fruits} className="card-img-top" alt="allfruit" />
                </a>
                <div className="card-body">
                  <h5 className="card-title">All type fruits</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <a href='krishnagar_famous-Matir-putul'>
                <div className="card">
                  <img src={krishnagarmatirputul} className="card-img-top" alt="krishnagarmatirputul" />
                  <div className="card-body">
                    <h5 className="card-title">Krishnagar Famous Matir Putul</h5>
                    <a href="krishnagar_famous-Matir-putul" className="exporterindia">Learn More</a>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card">
                <img src={biri} className="card-img-top" alt="biri" />
                <div className="card-body">
                  <h5 className="card-title">Biri</h5>
                  <a href="#" className="exporterindia">Learn More</a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <a href='sarbhja-sarpuria'>
                <div className="card">
                  <img src={sarbhajasarpuria} className="card-img-top" alt="sarbhajasarpuria" />
                  <div className="card-body">
                    <h5 className="card-title">Sarbhaja & Sarpuria</h5>
                    <a href="sarbhja-sarpuria" className="exporterindia">Learn More</a>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />
      <hr />
      <div className="album py-1">
        <div className="container">
          <h1><b>THE HOPING SUN EXIM Details</b></h1>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">

          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b>ADRESS </b>
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6 style={{ color: "darkBlue" }} className="card-text "> <b>THE HOPING SUN EXIM</b></h6>

                  <p style={{ color: "darkBlue" }} className="card-text mb-1">ADDRESS : Kanti Kuri Lane Niler Math, Krishnagar, Pin- 741101, Dist- Nadia, West Bengal, India</p>




                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <b>CONTACT</b>
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                  <a href="tel: +91 8695269630">
                    <p style={{ color: "darkBlue" }} className="mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                    </svg> +91 8695269630</p>
                  </a>

                  <a href="tel: +91 8918639629">
                    <p style={{ color: "darkBlue" }} className="mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                    </svg> +91 8918639629</p>
                  </a>

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <b>OUR MISSION</b>
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>Our mission is to bridge the gap between superior-quality Indian products and global demand. We aim to deliver excellence while fostering long-term relationships with our clients through trust, transparency, and reliability.</h6>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <br />
      <div className="album py-0">
        <div className="container">
          <h2><b>Cane Furniture</b></h2>
        </div>
      </div>
      <Canefurnitures />
      <br />
      <div className="album py-0">
        <div className="container">
          <h1><b>Dhaniya </b>(Coriander Seeds)</h1>
        </div>
      </div>
      <Dhaniya />
      <div className="album py-1">
        <div className="container">
          <h2><b>Garments </b>Products Exporter</h2>
        </div>
      </div>
      <Garments />
      <br />
    </div>
  )
}

export default Home